import { PureComponent, PropsWithChildren } from "react";

export default class InventoryFilterAdvancedFilterOptions extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-inventory-filter__adv-filter-options">
        {this.props.children}
      </div>
    );
  }
}
